import {observer} from 'mobx-react-lite'
import React from 'react'
import {useImportFromFileStore} from '../import-from-file-store'
import {MainMsg} from './containers'
import DeleteIcon from './delete-icon.svg'
import FileIcon from './file-icon.svg'

export const FileSelected = observer(() => {
  const [, store] = useImportFromFileStore()
  return (
    <div
      className="
        bg-main-even-old
        border-1
        flex
        flex-row
        items-center
        border-action-default
        w-full
        border-dashed
        rounded-4
        p-8"
    >
      <MainMsg>
        <FileIcon className="mr-6" />
        {store.state.selectedFile.name}
      </MainMsg>
      <div className="flex-grow" />
      <DeleteIcon
        onClick={() => store.clearFile()}
        className="cursor-pointer"
      />
    </div>
  )
})
